import React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker'
import TextInput from '../textinput/TextInput'
import { LabelInput } from '../../Main'

const InputDatePicker = (data) => {
  const {
    label,
    labelInput,
    value,
    setValue,
    inputTextStyle,
    labelStyle = { color: '#444', fontWeight: '700', fontSize: '0.875rem' },
    required,
    ...otherProps
  } = data
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      {labelInput && (
        <LabelInput sx={{ ...labelStyle }}>
          {labelInput}
          {required && <span style={{ color: 'red' }}>*</span>}
        </LabelInput>
      )}
      <MobileDatePicker
        label={label || ''}
        inputFormat="YYYY-MM-DD"
        value={value}
        onChange={setValue}
        showToolbar={false}
        renderInput={(params) => <TextInput sx={{ ...inputTextStyle }} {...params} />}
        {...otherProps}
      />
    </LocalizationProvider>
  )
}

export default InputDatePicker
